import { lazy } from 'react';
import Loadable from 'core/components/Loadable';

import { LAYOUT_VITICULTOR } from '../core/constants';
import * as constants from 'store/entities/constants';

const Dashboard = Loadable(
    lazy(() => import('views/b2b/viticultores/Dashboard'))
);
const NotFound = Loadable(lazy(() => import('entorno/notfound')));
const ReportView = Loadable(lazy(() => import('reports')));
const FormView = Loadable(lazy(() => import('reports/components/Report')));

export const viticultorRoutes = layouts => [
    {
        path: '/Report/:Report',
        element: <ReportView />
    },
    {
        path: '/form/:form',
        element: <FormView />
    },
    {
        path: '/',
        element: layouts[LAYOUT_VITICULTOR],
        children: [
            {
                path: '/',
                element: <Dashboard />
            },
            {
                path: '/b2b/viticultor/dashboard',
                element: <Dashboard />
            }
        ]
    },
    { path: '*', element: <NotFound /> }
];
